export function unknown(input: unknown) {
	return input
}
